var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessages(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 4.2333333 4.2333333",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 0.20959598,0.38469668 A 0.20955635,0.20955635 0 0 0 -0.00103076,0.59532341 V 3.6390434 A 0.20955635,0.20955635 0 0 0 0.20959598,3.8496702 H 4.0227038 A 0.20955635,0.20955635 0 0 0 4.2333306,3.6390434 V 1.307962 0.59532341 A 0.20955635,0.20955635 0 0 0 4.0227038,0.38469668 Z M 0.41967705,0.80322182 H 3.8148054 V 1.1879157 L 2.1172412,2.1832089 0.41967705,1.1884614 Z m 0,0.87142728 1.59006815,0.9314503 a 0.20955635,0.20955635 0 0 0 0.2128094,0 L 3.8148054,1.6746491 V 3.4289624 H 0.41967705 Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessages);
export default __webpack_public_path__ + "static/media/messages.eb61bcc4afc7674d380297a4d0876c6f.svg";
export { ForwardRef as ReactComponent };